module.exports = __webpack_public_path__ + "img/applyOversea.eb69b504.jpg";